import { render, staticRenderFns } from "./PpaInactiveLeadCheckControl.vue?vue&type=template&id=2f658d7a&scoped=true"
import script from "./PpaInactiveLeadCheckControl.vue?vue&type=script&lang=js"
export * from "./PpaInactiveLeadCheckControl.vue?vue&type=script&lang=js"
import "./PpaInactiveLeadCheckControl.vue?vue&type=style&index=0&id=2f658d7a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f658d7a",
  null
  
)

export default component.exports